<template>
    <Link class="w-full p-2 lg:w-1/4 md:w-1/2" :href="cardLink">
        <div
            class="flex flex-col px-6 py-10 overflow-hidden bg-white hover:bg-gradient-to-br hover:from-purple-400 hover:via-blue-400 hover:to-blue-500 rounded-xl shadow-lg duration-300 hover:shadow-2xl group">
            <div class="flex flex-row justify-between items-center">
                <div class="px-4 py-4 bg-gray-300  rounded-xl bg-opacity-30">
                    <slot name="cardIcon"></slot>
                </div>
                <div class="inline-flex text-sm text-gray-600 group-hover:text-gray-200 sm:text-base">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="h-6 w-6 mr-2 group-hover:text-gray-200"
                         :class="change_direction ? 'text-green-500' : 'text-red-500'"
                         fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              :d="change_direction ? 'M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z' :'M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z'  "/>
                    </svg>
                    {{ percentage_change }} %
                </div>
            </div>
            <h1 class="text-3xl sm:text-4xl xl:text-5xl font-bold text-gray-700 mt-12 group-hover:text-gray-50">
                {{ totals }} </h1>
            <div class="flex flex-row justify-between group-hover:text-gray-200">
                <p>{{ title }}</p>
                <span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-600 group-hover:text-gray-200"
                 viewBox="0 0 20 20" fill="currentColor">
            </svg>
          </span>
            </div>
        </div>
    </Link>

</template>

<script>

import {Link} from "@inertiajs/inertia-vue3";
export default {
    components: {
        Link
    },
    name: "SummaryCard",
    props: {
        title: String,
        totals: Number,
        percentage_change: Number,
        change_direction: Boolean,
        iconFilename: String,
        cardLink : String
    },
    computed: {}


}
</script>

<style scoped>

</style>
